export default {
    tooltip: 'Προσαρμογή θερμίδων: αναλογική αύξηση ή μείωση των ποσοτήτων',
    badge: 'Beta',
    title: 'Προσαρμογή θερμίδων',
    modes: {
        percent: 'Ποσοστό',
        fixed: 'Σταθερές θερμίδες',
    },
    fixedLabel: 'Θερμίδες ανά ημέρα',
    averagePerDay: 'Μέσος όρος ανά ημέρα',
    emptyDay: 'Χωρίς τρόφιμα',
    unchanged: 'Χωρίς αλλαγή',
    selectAll: 'Επιλογή όλων',
    deselectAll: 'Αποεπιλογή όλων',
    noFoods: 'Το πλάνο δεν έχει ακόμη τρόφιμα για προσαρμογή.',
    largeChange: 'Οι ημέρες με κόκκινο αλλάζουν πάνω από 25% και τα γεύματά τους μπορεί να χρειαστούν έλεγχο.',
    hint: 'Οι θερμίδες είναι κατά προσέγγιση καθώς υπάρχει στρογγυλοποίηση των ποσοτήτων, για να είναι πιο φυσιολογικές οι τιμές. Μπορεί να γίνει αναίρεση της τροποποίησης.',
    apply: 'Εφαρμογή',
    done: 'Μέσος όρος ανά ημέρα: {before} → {after} kcal',
};
